module.exports = __webpack_public_path__ + "img/bermuda3.94089a5e.jpg";